import axios from "axios";
//import config from "../config/config.json"

export const getSession = async (eraId,tokenClient) => {

  let config = require(`../config/${tokenClient}/config.json`);

  const headers = {
    'Content-Type': "application/json",
    'token': config.credential.session.token
  };

  const url = config.credential.session.url+'?session='+eraId;

  const response = await axios.get(url,{headers:headers})
 
  //const response = await axios.post(url)
    .then(res => {

      return res;
    })
    .catch((err) => {

      return false;
    }); 

  return response;
}

